var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_25982)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "url(#paint0_linear_1_25982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9993 29.9976C57.9993 14.5336 45.4632 1.99756 29.9993 1.99756C14.5353 1.99756 1.99927 14.5336 1.99927 29.9976C1.99927 45.4615 14.5353 57.9976 29.9993 57.9976C45.4632 57.9976 57.9993 45.4615 57.9993 29.9976Z",
    fill: "url(#paint1_linear_1_25982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 57C15.1005 57 3 44.8822 3 30C3 15.1178 15.1178 3 30 3C44.8822 3 57 15.1178 57 30C57 44.8822 44.8822 57 30 57Z",
    fill: "url(#paint2_linear_1_25982)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_25982",
    x1: 59.2312,
    y1: 59.2312,
    x2: 0.768773,
    y2: 0.768773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03539"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_25982",
    x1: 11.4686,
    y1: 11.4669,
    x2: 48.9689,
    y2: 48.9672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F54141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_25982",
    x1: 50.1489,
    y1: 49.6627,
    x2: 8.82016,
    y2: 10.2788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA2228"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_25982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBEmpty);
export default __webpack_public_path__ + "static/media/b_empty.da2a50a24be3b43a51ebd3a05e062bc8.svg";
export { ForwardRef as ReactComponent };